import React, {useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Components/BodySite.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import Botonera from "./Botonera";
import BotoneraWithFooter from "./BotoneraWithFooter";



const BotoneraGratuitosBis = () => {
    const navigate = useNavigate();
    const [lugar, setLugar] = useState({lugar: "123"});

    const changeHandler = (e) => {
        const { name, value } = e.target;
        //alert("monos");
        setLugar({
          ...lugar,
          [name]: value,
        });
        //alert(patente).;
      };

    return (
        <>
       <section>
       <main>
       

       
     
       <div class="containerFull">
                
       <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/estacionamientodonde")}}/>
                
            <iframe src="https://mimuni.app/lugares" class="frameContentSpec" frameborder="0" scrolling="yes" ></iframe>
       
        
        </div>
       
        </main>
        </section>
        </>

    );
    }
export default BotoneraGratuitosBis;